import { Box, Button, Col, Text } from '@opendoor/bricks-next';
import { EntryComponent } from 'cms/entries/entries';
import { IFcValueTracker } from 'declarations/contentful';

import Container from './shared/Container';

const RenderFCValueTracker = (entry: IFcValueTracker) => {
  const { fields } = entry;

  return (
    <Container style={{ backgroundColor: '#ece9e7' }} noSectionSpacing>
      <Col
        alignItems="center"
        justifyContent="center"
        paddingTop="$22x"
        paddingBottom="$28x"
        gap="$6x"
        minHeight={609}
        $largerThanSM={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingTop: '$27x',
          paddingBottom: '$27x',
          gap: '$10x',
          minHeight: 333,
        }}
      >
        <Col
          alignItems="center"
          gap="$4x"
          $largerThanSM={{ flex: 1, alignItems: 'flex-start', maxWidth: 540, gap: '$10x' }}
        >
          <Text
            tag="h2"
            typography="$headerMedium"
            color="$contentPrimary"
            textAlign="center"
            $largerThanSM={{ typography: '$headerLarge', textAlign: 'left' }}
            css={{
              '@media (min-width: 768px)': {
                fontSize: '50px !important',
              },
            }}
          >
            {fields.title}
          </Text>
          <Text
            tag="p"
            typography="$bodyXlarge"
            color="$contentPrimary"
            textAlign="center"
            maxWidth={320}
            $largerThanSM={{ textAlign: 'left', maxWidth: 465 }}
          >
            {fields.description}
          </Text>
          <Button
            variant="primary"
            size="large"
            label={fields.ctaButtonText}
            analyticsName="cosmos-fc-value-tracker-cta"
            href={fields.ctaUrl}
            display="none"
            $largerThanSM={{ display: 'flex' }}
          />
        </Col>
        {/* Mobile value tracker image */}
        <Box
          tag="img"
          // @ts-expect-error img attributes not typed on Box
          src="https://images.opendoor.com/source/s3/imgdrop-production/2026-02-1770777570549-33022.png?service=cosmos"
          alt="Home value tracker"
          width="100%"
          maxWidth={333}
          borderRadius="$4x"
          $largerThanSM={{ display: 'none' }}
        />
        {/* Desktop value tracker image */}
        <Box
          tag="img"
          // @ts-expect-error img attributes not typed on Box
          src="https://images.opendoor.com/source/s3/imgdrop-production/2026-02-1770777574858-89708.png?service=cosmos"
          alt="Home value tracker"
          display="none"
          borderRadius="$4x"
          $largerThanSM={{
            display: 'flex',
            width: 700,
            maxWidth: 700,
            flex: 1,
          }}
        />
        <Button
          variant="primary"
          size="small"
          label={fields.ctaButtonText}
          analyticsName="cosmos-fc-value-tracker-cta"
          href={fields.ctaUrl}
          $largerThanSM={{ display: 'none' }}
        />
      </Col>
    </Container>
  );
};

const FCValueTracker: EntryComponent<IFcValueTracker> = {
  render: RenderFCValueTracker,
};

export default FCValueTracker;
